/** Add selected gift products in the same Shopify request as the main product.
 * Scoped to this product's variant IDs; unrelated app/cart requests pass through.
 * Keep Shopify's response intact so the theme and Teeinblue handle their own UI.
 */
(function () {
  if (window.__mangofyAddons) return;
  window.__mangofyAddons = true;
  var originalFetch = window.fetch;

  function decode(body) {
    if (typeof body === 'string') return JSON.parse(body);
    if (!(body instanceof FormData) && !(body instanceof URLSearchParams)) return null;
    // Theme product-form sends a flat multipart product form.
    if (!body.has('id') || Array.from(body.values()).some(function (value) { return typeof value !== 'string'; })) return null;
    var item = { id: body.get('id'), quantity: Number(body.get('quantity') || 1), properties: {} };
    body.forEach(function (value, key) {
      var property = key.match(/^properties\[(.*)\]$/);
      if (property) item.properties[property[1]] = value;
    });
    if (body.get('selling_plan')) item.selling_plan = body.get('selling_plan');
    var payload = { items: [item] };
    ['sections', 'sections_url'].forEach(function (key) { if (body.has(key)) payload[key] = body.get(key); });
    return payload;
  }

  window.fetch = function (input, init) {
    var area = document.querySelector('[data-product-addons]');
    var url = typeof input === 'string' || input instanceof URL ? new URL(input, location.href) : null;
    if (!area || !url || url.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname) || !init || (init.method || 'GET').toUpperCase() !== 'POST') {
      return originalFetch.apply(this, arguments);
    }
    var payload;
    try { payload = decode(init.body); } catch (_) { return originalFetch.apply(this, arguments); }
    if (!payload) return originalFetch.apply(this, arguments);
    var items = payload.items || (payload.id ? [{ id: payload.id, quantity: payload.quantity || 1, properties: payload.properties || {}, selling_plan: payload.selling_plan }] : []);
    var variants = JSON.parse(area.dataset.mainVariants).map(String);
    var main = items.find(function (item) { return variants.indexOf(String(item.id)) !== -1; });
    if (!main) return originalFetch.apply(this, arguments);
    var selected = Array.from(area.querySelectorAll('[data-product-addon]:checked'));
    if (!selected.length) return originalFetch.apply(this, arguments);
    selected.forEach(function (checkbox) {
      if (!items.some(function (item) { return String(item.id) === checkbox.value; })) {
        items.push({ id: Number(checkbox.value), quantity: Number(main.quantity || 1) });
      }
    });
    var next = Object.assign({}, payload, { items: items });
    ['id', 'quantity', 'properties', 'selling_plan'].forEach(function (key) { delete next[key]; });
    var headers = new Headers(init.headers);
    headers.set('Content-Type', 'application/json');
    var error = area.querySelector('[role="alert"]');
    error.hidden = true;
    return originalFetch.call(this, input, Object.assign({}, init, { headers: headers, body: JSON.stringify(next) })).then(function (response) {
      if (!response.ok) {
        error.textContent = 'Some items could not be added. Please check your cart and item availability before trying again.';
        error.hidden = false;
        var cart = document.querySelector('side-cart');
        if (cart && typeof cart.refresh === 'function') cart.refresh({ open: true }).catch(function () {});
      }
      return response;
    }).catch(function (reason) {
      error.textContent = 'Could not confirm the cart update. Please check your cart before trying again.';
      error.hidden = false;
      throw reason;
    });
  };
})();
